export const stateRequirements = {
  AL: {
    name: 'Alabama',
    // Initial Fee refers to Charity Reg; Incorporation separate ($100+)
    initialFee: 25, // Initial Charity Registration Fee (AG) if required (e.g., >$25k contrib)
    renewalFee: 25, // Annual Charity Registration Renewal Fee (AG)
    auditThreshold: null, // No specific threshold found via search
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits transacting business (SoS)
    foreignEntityFee: 150, // Fee for Foreign Corporation Certificate of Authority (SoS)
    solicitationRequired: true, // Charitable solicitation registration required with AG if contributions > $25k (subject to exemptions)
    registeredAgentRequired: true, // Required for incorporation/foreign registration (SoS)
    renewalFrequency: 'Annual', // For Charitable Registration with AG
    requirements: [
        'Annual Charitable Registration Renewal (AG)',
        'Copy of IRS Form 990 (AG)',
        'Foreign Corporation Certificate of Authority if applicable (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  AK: {
    name: 'Alaska',
    // initialFee refers to Charity Reg; Incorporation separate ($25)
    initialFee: 40, // Initial Charitable Organization Registration Fee (Dept of Law)
    renewalFee: 40, // Annual Charitable Organization Renewal Fee (Dept of Law - by Sep 1)
    auditThreshold: null, // General threshold not found; $750k expense threshold if receiving state funds
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (Dept of Commerce)
    foreignEntityFee: 50, // Fee for Foreign Non Profit Certificate of Authority (Dept of Commerce)
    solicitationRequired: true, // Charitable solicitation registration required (Dept of Law)
    registeredAgentRequired: true, // A registered agent is mandatory (Dept of Commerce)
    renewalFrequency: 'Annual / Biennial', // Annual Charity Reg (Dept of Law), Biennial Corp Report (Dept of Commerce)
    requirements: [
        'Initial Charitable Organization Registration (Dept of Law)',
        'Annual Charity Renewal (Dept of Law - by Sep 1)',
        'Biennial Report (Dept of Commerce - by July 2, $25 fee)',
        'Maintain Registered Agent (Dept of Commerce)'
        ]
  },
  AZ: {
    name: 'Arizona',
    initialFee: 40, // Fee for Articles of Incorporation (ACC)
    renewalFee: 10, // Fee for Annual Report (ACC)
    auditThreshold: null, // No specific threshold found via search
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (ACC)
    foreignEntityFee: 175, // Fee for Application for Authority (ACC)
    solicitationRequired: false, // No general charitable solicitation registration required (except Veterans Orgs with SoS)
    registeredAgentRequired: true, // A statutory agent is mandatory (ACC)
    renewalFrequency: 'Annual', // Annual Report filing required (ACC)
    requirements: [
        'Articles of Incorporation (ACC)',
        'Annual Report (ACC)',
        'Maintain Statutory Agent (ACC)',
        'Foreign Nonprofit Application for Authority if applicable (ACC)'
        ]
  },
  AR: {
    name: 'Arkansas',
    initialFee: 45, // Filing fee for Articles of Incorporation (SoS online, $50 paper)
    renewalFee: 0, // No fee for Annual Report (SoS)
    auditThreshold: 500000, // Audit required if gross revenue > $500k (Ark. Code §4-28-403(b))
    reviewThreshold: null, // No specific review threshold found
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 270, // Filing fee for Certificate of Authority (SoS online, $300 paper)
    solicitationRequired: true, // Charitable solicitation registration is required (with SoS)
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual', // Annual Report required (SoS - by Aug 1)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Annual Report (SoS - includes financial info)', // Specific content needs review
        'Charitable Organization Registration (SoS)',
        'Annual Charity Registration Renewal (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  CA: {
    name: 'California',
    initialFee: 50, // Initial Registration Fee (Form CT-1 with AG)
    renewalFee: 25, // Minimum Annual Renewal Fee (Form RRF-1 with AG); Tiered $25-$1200 based on revenue
    auditThreshold: 2000000, // Audit required if gross revenue >= $2M (AG)
    reviewThreshold: null, // No separate review threshold found (replaced by $2M audit)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits transacting business (SoS)
    foreignEntityFee: 30, // Fee for Statement and Designation by Foreign Corporation (SoS - approx, verify current)
    solicitationRequired: true, // Initial and annual registration required with AG
    registeredAgentRequired: true, // Required for incorporation/foreign registration (SoS)
    renewalFrequency: 'Annual', // For AG charitable registration (Form RRF-1)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Initial Registration Form CT-1 (AG)',
        'Annual RRF-1 Filing (AG)',
        'Copy of IRS Form 990/EZ/PF (excluding Sch B) or CT-TR-1 (AG)',
        'Maintain Registered Agent (SoS)',
        'FTB Tax Exemption/Filings'
        ]
  },
  CO: {
    name: 'Colorado',
    initialFee: 50, // Fee for Articles of Incorporation (SoS)
    renewalFee: 25, // Fee for Periodic Report (SoS)
    auditThreshold: null, // No specific threshold found via search
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 100, // Filing fee for Statement of Foreign Entity Authority (SoS)
    solicitationRequired: true, // Registration with SoS Charities Program required (covered by incorporation/periodic report)
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual', // Periodic Report required (SoS)
    requirements: [
        'Articles of Incorporation or Statement of Foreign Entity Authority (SoS)',
        'Periodic Report (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  CT: {
    name: 'Connecticut',
    initialFee: 50, // Initial Charity Registration fee (DCP)
    renewalFee: 50, // Annual Charity Registration renewal fee (DCP)
    auditThreshold: 1000000, // Audit required if gross revenue >= $1M (excluding gov grants/trusts) (DCP)
    reviewThreshold: 500000, // (Unverified) Independent review if gross revenue $500k-$1M
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 40, // Fee for Foreign Corporation Application for Certificate of Authority (SoS - approx, verify current)
    solicitationRequired: true, // Charitable solicitation registration is required (DCP)
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual', // Annual Charity renewal required (DCP)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Initial Charity Registration Application (DCP)',
        'Annual Charity Financial Report (DCP)',
        'Independent Audit (or Review - unverified) based on revenue (DCP)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  DE: {
    name: 'Delaware',
    initialFee: 109, // Filing fee for Certificate of Incorporation (Exempt Corp, Div of Corps)
    renewalFee: 25, // Annual Report filing fee for exempt corporations (Div of Corps, by Mar 1)
    auditThreshold: null, // No specific state requirement found
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (Div of Corps)
    foreignEntityFee: 245, // Fee for Foreign Corporation Qualification (Div of Corps)
    solicitationRequired: false, // No state charitable solicitation registration requirement found
    registeredAgentRequired: true, // A registered agent is mandatory (Div of Corps)
    renewalFrequency: 'Annual', // Annual Report required (Div of Corps)
    requirements: [
        'Certificate of Incorporation (Div of Corps)',
        'Annual Report & Franchise Tax (Div of Corps)', // Tax is $0 for exempt
        'Maintain Registered Agent (Div of Corps)',
        'Register w/ Div of Revenue for withholding tax',
        'Private Foundations file 990-PF with AG'
        ]
  },
  FL: {
    name: 'Florida',
    initialFee: 10, // Minimum Initial Solicitation Registration Fee (FDACS); Tiered $10/$75-$400 based on contributions
    renewalFee: 10, // Minimum Annual Solicitation Renewal Fee (FDACS); Tiered $10/$75-$400 based on contributions
    auditThreshold: 1000000, // Audit required if annual contributions >= $1M (FDACS - based on unverified source)
    reviewThreshold: 500000, // Review required if annual contributions $500k-$1M (FDACS - based on unverified source)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits transacting business (Dept of State)
    foreignEntityFee: 35, // Fee for Foreign Non-Profit Certificate of Authority (Dept of State - approx, verify current)
    solicitationRequired: true, // Solicitation registration required (FDACS)
    registeredAgentRequired: true, // Required for incorporation/foreign registration (Dept of State)
    renewalFrequency: 'Annual', // For Solicitation Registration with FDACS
    requirements: [
        'Articles of Incorporation (Dept of State)',
        'Solicitation of Contributions Act Registration (FDACS)',
        'Annual Renewal Registration & Financial Reporting (FDACS)',
        'Audit or Review based on contribution level (FDACS)',
        'Maintain Registered Agent (Dept of State)'
        ]
  },
  GA: {
    name: 'Georgia',
    // $100 (+svc) for Articles of Incorporation (SoS)
    // $30 Initial Corp Annual Reg within 90 days (SoS)
    initialFee: 35, // Initial Charitable Organization Registration Fee (SoS)
    renewalFee: 20, // Annual Charitable Organization Renewal Fee (SoS)
    // Also Annual Corp Registration Renewal Fee ($35/$40) due Apr 1 (SoS)
    auditThreshold: 1000000, // Audit required if contributions > $1M (SoS)
    reviewThreshold: 500000, // Review required if contributions $500k-$1M (SoS)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 225, // Filing fee for Certificate of Authority (+svc charge?) (SoS)
    solicitationRequired: true, // Charitable solicitation registration is required (SoS)
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual', // For both Charity Reg and Corp Annual Reg (SoS)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Initial Corporate Annual Registration (SoS)',
        'Charitable Organization Registration (C-100 Form, SoS)',
        'Annual Charitable Organization Renewal (SoS)',
        'Annual Corporate Registration Renewal (SoS)',
        'Audit or Review based on contribution level (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  HI: {
    name: 'Hawaii',
    initialFee: 25, // Filing fee for Articles of Incorporation (DCCA)
    // Separate AG Charity Reg Fee likely $0 (unverified)
    renewalFee: 5, // Annual Corporation Report filing fee (DCCA)
    // Separate AG Annual Financial Report Fee Tiered $10-$600 (unverified)
    auditThreshold: null, // General threshold not found; specific requirement if gross revenue > $500k excluding gov grants/trusts (unverified source)
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (DCCA)
    foreignEntityFee: 25, // Filing fee for Certificate of Authority (DCCA)
    solicitationRequired: true, // Charitable solicitation registration is required (AG)
    registeredAgentRequired: true, // A registered agent is mandatory (DCCA)
    renewalFrequency: 'Annual', // For DCCA Corp Report & AG Financial Report
    requirements: [
        'Articles of Incorporation (Form DNP-1) (DCCA)',
        'Charitable Solicitation Registration (AG)',
        'Annual Corporation Report (DCCA)',
        'Annual Financial Report (AG)', // Requires copy of Form 990
        'Maintain Registered Agent (DCCA)'
        ]
  },
  ID: {
    name: 'Idaho',
    initialFee: 30, // Filing fee for Articles of Incorporation (+ $20 if paper) (SoS)
    renewalFee: 0, // Fee for Annual Report (SoS)
    auditThreshold: 750000, // (Unverified from initial object)
    reviewThreshold: 250000, // (Unverified from initial object)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 30, // Fee for Foreign Registration Statement (+ $20 if paper) (SoS)
    solicitationRequired: false, // No general charitable solicitation registration required (AG)
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual', // Annual Report required (SoS, by end of anniversary month)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Annual Report (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  IL: {
    name: 'Illinois',
    initialFee: 15, // Initial Charity Registration Fee (AG, Form CO-1)
    renewalFee: 15, // Annual Report Fee (AG, Form AG990-IL, if threshold met)
    // Audit/Review triggered by contribution level and fundraiser type
    auditThreshold: 500000, // Audit required if contributions > $500k (if using only staff/volunteers)
    reviewThreshold: 300000, // Review required if contributions $300k-$500k (if using only staff/volunteers)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 75, // Fee for Application for Authority (SoS - approx, verify current)
    solicitationRequired: true, // Charitable registration required with AG
    registeredAgentRequired: true, // Required for incorporation/foreign registration (SoS)
    renewalFrequency: 'Annual', // For AG Annual Report (AG990-IL)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Initial Charity Registration Form CO-1 (AG)',
        'Annual Form AG990-IL (AG)',
        'Annual Financial Report (incl. Audit/Review if required) (AG)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  IN: {
    name: 'Indiana',
    initialFee: 30, // Fee for Articles of Incorporation (SoS)
    renewalFee: 10, // Fee for Business Entity Report (SoS - $6 if online)
    auditThreshold: null, // No specific state requirement found
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 30, // Fee for Foreign Certificate of Authority (SoS - approx, verify current)
    solicitationRequired: false, // No specific charitable solicitation registration found
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual', // Business Entity Report required (SoS)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Business Entity Report (SoS)',
        'Maintain Registered Agent (SoS)',
        'Register w/ Dept of Revenue for Tax ID/Exemption (Form NP-20A)'
        ]
  },
  IA: {
    name: 'Iowa',
    initialFee: 20, // Fee for Articles of Incorporation (SoS)
    renewalFee: 0, // Fee for Biennial Report (SoS)
    auditThreshold: 500000, // (Unverified from initial object)
    reviewThreshold: 250000, // (Unverified from initial object)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 25, // Fee for Certificate of Authority (SoS)
    solicitationRequired: false, // No specific charitable solicitation registration found
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Biennial', // Biennial Report required (SoS, odd years, by Apr 1)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Biennial Report (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  KS: {
    name: 'Kansas',
    initialFee: 20, // Fee for Articles of Incorporation (SoS)
    // $25 Initial Charity Reg Fee with AG
    renewalFee: 20, // Fee for Biennial Information Report (SoS - online)
    // $25 Annual Charity Reg Renewal Fee with AG
    auditThreshold: 500000, // Audit required if contributions > $500k (AG)
    reviewThreshold: null, // No specific review threshold found
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 35, // Fee for Foreign Application for Authority (SoS - approx, verify current)
    solicitationRequired: true, // Charitable solicitation registration is required (AG)
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual / Biennial', // Annual Charity Reg (AG), Biennial Corp Report (SoS)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Charitable Organization Registration (AG)',
        'Annual Charity Registration Renewal & Financials (AG)',
        'Biennial Information Report (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  KY: {
    name: 'Kentucky',
    initialFee: 8, // Filing fee for Articles of Incorporation (SoS)
    // Charity Reg with AG required, $0 Fee per URS instructions (verify)
    renewalFee: 15, // Fee for Annual Report (SoS)
    // Annual Charity Reg renewal with AG required, $0 Fee per URS (verify)
    auditThreshold: null, // No specific threshold found via search
    reviewThreshold: null,
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 90, // Fee for Application for Certificate of Authority (SoS)
    solicitationRequired: true, // Charitable solicitation registration is required (AG)
    registeredAgentRequired: true, // A registered agent is mandatory (SoS)
    renewalFrequency: 'Annual', // Annual Report (SoS, by Jun 30) & Annual Charity Renewal (AG)
    requirements: [
        'Articles of Incorporation (SoS)',
        'Charitable Organization Registration (AG)', // URS or Form 990 acceptable
        'Annual Report (SoS)',
        'Annual Charity Registration Renewal (AG)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  // NOTE: Data for LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NY, NC, ND, OH, OK
  // could not be reliably verified via search and is left as originally provided.
  // Manual verification is required for these states.
  LA: {
    name: 'Louisiana',
    initialFee: 25,
    renewalFee: 25,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  ME: {
    name: 'Maine',
    initialFee: 50,
    renewalFee: 25,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  MD: {
    name: 'Maryland',
    initialFee: 300,
    renewalFee: 200,
    auditThreshold: 500000,
    reviewThreshold: 200000,
    requirements: ['Charitable Organization Registration', 'Annual Update Form', 'Secretary of State Filing']
  },
  MA: {
    name: 'Massachusetts',
    initialFee: 50,
    renewalFee: 35,
    auditThreshold: 500000,
    reviewThreshold: 200000,
    requirements: [
        'Form PC Initial Registration',
        'Annual Form PC Filing',
        'Annual Financial Statements',
        'Professional Solicitor Registration if applicable',
        'Certificate of Solicitation if applicable'
        ]
  },
  MI: {
    name: 'Michigan',
    initialFee: 20,
    renewalFee: 20,
    auditThreshold: 525000,
    reviewThreshold: 275000,
    requirements: [
        'Initial Charitable Trust Registration',
        'Annual Charitable Trust Registration',
        'Form CTS-85 if soliciting',
        'Professional Fundraiser Registration if applicable',
        'Registered Agent Required'
        ]
  },
  MN: {
    name: 'Minnesota',
    initialFee: 25,
    renewalFee: 25,
    auditThreshold: 750000,
    reviewThreshold: 350000,
    requirements: [
        'Initial Charitable Organization Registration',
        'Annual Report',
        'Professional Fundraiser Registration if applicable',
        'Solicitation Campaign Financial Report',
        'Registered Agent Required'
        ]
  },
  MS: {
    name: 'Mississippi',
    initialFee: 50,
    renewalFee: 50,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  MO: {
    name: 'Missouri',
    initialFee: 15,
    renewalFee: 15,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  MT: {
    name: 'Montana',
    initialFee: 0,
    renewalFee: 0,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['No Registration Required']
  },
  NE: {
    name: 'Nebraska',
    initialFee: 0,
    renewalFee: 0,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['No Registration Required']
  },
  NV: {
    name: 'Nevada',
    initialFee: 60,
    renewalFee: 60,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  NH: {
    name: 'New Hampshire',
    initialFee: 75, // (Unverified) Fee for Charitable Trust Registration (AG)
    renewalFee: 75, // (Unverified) Fee for Annual Report (AG)
    auditThreshold: 500000, // (Unverified)
    reviewThreshold: 250000, // (Unverified)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 100, // Fee for Application for Authority (SoS - approx, verify current)
    solicitationRequired: true, // Charitable Trust Registration required (AG)
    registeredAgentRequired: true, // Required for incorporation/foreign registration (SoS)
    renewalFrequency: 'Annual', // For AG Annual Report
    requirements: [
        'Articles of Incorporation (SoS)',
        'Charitable Trust Registration (Form NHCT-11) (AG)',
        'Annual Report (Form NHCT-12) (AG)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  NJ: {
    name: 'New Jersey',
    initialFee: 30, // Minimum Initial Registration Fee (CRI-150I) (Consumer Affairs); Tiered $30-$250 based on contributions
    renewalFee: 30, // Minimum Annual Renewal Fee (CRI-200/300R) (Consumer Affairs); Tiered $30-$250 based on contributions
    // $25 Late Fee applies
    auditThreshold: 1000000, // Audit required if gross revenue >= $1M (Consumer Affairs - based on unverified source)
    reviewThreshold: null, // No specific review threshold found
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (Dept of Treasury)
    foreignEntityFee: 125, // Fee for Certificate of Authority (Dept of Treasury - approx, verify current)
    solicitationRequired: true, // Charitable registration required (Consumer Affairs)
    registeredAgentRequired: true, // Required for incorporation/foreign registration (Dept of Treasury)
    renewalFrequency: 'Annual', // For Charity Renewal (Consumer Affairs)
    requirements: [
        'Certificate of Incorporation (Dept of Treasury)',
        'Initial Charity Registration (CRI-150I) (Consumer Affairs)',
        'Annual Charity Renewal (CRI-200/300R) (Consumer Affairs)',
        'Annual Financial Report (incl. Audit if required) (Consumer Affairs)',
        'Maintain Registered Agent (Dept of Treasury)'
        ]
  },
  NM: {
    name: 'New Mexico',
    initialFee: 0, // Incorporation fee needed (SoS online portal - approx $25?)
    renewalFee: 0, // Annual/Biennial Report fee needed? (Often $0-$25 if required)
    auditThreshold: 500000, // (Unverified from initial object)
    reviewThreshold: 250000, // (Unverified from initial object)
    foreignEntityRegistration: true, // Required for out-of-state nonprofits (SoS)
    foreignEntityFee: 100, // Fee for Foreign Certificate of Authority (SoS - approx, verify current)
    solicitationRequired: false, // No specific charitable solicitation registration found
    registeredAgentRequired: true, // Required for incorporation/foreign registration (SoS)
    renewalFrequency: 'Annual', // Or Biennial? Needs verification (SoS)
    requirements: [
        'Articles of Incorporation (SoS online)',
        'Corporate Report? (SoS)',
        'Maintain Registered Agent (SoS)'
        ]
  },
  NY: {
    name: 'New York',
    initialFee: 25,
    renewalFee: 0,
    auditThreshold: 1000000,
    reviewThreshold: 250000,
    requirements: [
        'CHAR410 Initial Registration',
        'Annual CHAR500 Filing',
        'Annual Form 990 Filing',
        'Schedule 4a/4b for Professional Fundraisers',
        'Registration with Attorney General Charities Bureau'
        ]
  },
  NC: {
    name: 'North Carolina',
    initialFee: 50,
    renewalFee: 50,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization License', 'Annual Report']
  },
  ND: {
    name: 'North Dakota',
    initialFee: 25,
    renewalFee: 10,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  OH: {
    name: 'Ohio',
    initialFee: 200,
    renewalFee: 200,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  OK: {
    name: 'Oklahoma',
    initialFee: 65,
    renewalFee: 65,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  OR: {
    name: 'Oregon',
    initialFee: 50,
    renewalFee: 50,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: [
        'Form CT-12 Initial Registration',
        'Annual Form CT-12',
        'Annual Financial Report',
        'Professional Fundraiser Registration if applicable',
        'Registered Agent Required'
        ]
  },
  PA: {
    name: 'Pennsylvania',
    initialFee: 125,
    renewalFee: 125,
    auditThreshold: 750000,
    reviewThreshold: 250000,
    requirements: [
        'Form BCO-10 Initial Registration',
        'Annual Form BCO-10',
        'Annual Financial Report',
        'Professional Solicitor Registration if applicable',
        'Registered Agent Required',
        'Disclosure Statement Requirements'
        ]
  },
  RI: {
    name: 'Rhode Island',
    initialFee: 90,
    renewalFee: 90,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  SC: {
    name: 'South Carolina',
    initialFee: 50,
    renewalFee: 50,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  SD: {
    name: 'South Dakota',
    initialFee: 0,
    renewalFee: 0,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['No Registration Required']
  },
  TN: {
    name: 'Tennessee',
    initialFee: 50,
    renewalFee: 50,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  TX: {
    name: 'Texas',
    initialFee: 0,
    renewalFee: 0,
    auditThreshold: 0,
    reviewThreshold: 0,
    requirements: [
        'No State Registration Required',
        'Form 802 for Law Enforcement Fundraising',
        'Annual Financial Report to Local Government if Required',
        'Secretary of State Business Filing if Incorporated'
        ]
  },
  UT: {
    name: 'Utah',
    initialFee: 100,
    renewalFee: 100,
    auditThreshold: 750000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  VT: {
    name: 'Vermont',
    initialFee: 0,
    renewalFee: 0,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['No Registration Required']
  },
  VA: {
    name: 'Virginia',
    initialFee: 100,
    renewalFee: 100,
    auditThreshold: 1000000,
    reviewThreshold: 500000,
    requirements: [
        'Form 100 Initial Registration',
        'Annual Form 102',
        'Annual Financial Report',
        'Professional Solicitor Registration if applicable',
        'Registered Agent Required',
        'Disclosure Statement Requirements'
        ]
  },
  WA: {
    name: 'Washington',
    initialFee: 60,
    renewalFee: 40,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: [
        'Charitable Organization Registration',
        'Annual Renewal',
        'Annual Financial Report',
        'Commercial Fundraiser Registration if applicable',
        'Registered Agent Required',
        'Trust Account Requirements if applicable'
        ]
  },
  WV: {
    name: 'West Virginia',
    initialFee: 15,
    renewalFee: 15,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  WI: {
    name: 'Wisconsin',
    initialFee: 54,
    renewalFee: 54,
    auditThreshold: 500000,
    reviewThreshold: 300000,
    requirements: ['Charitable Organization Registration', 'Annual Report']
  },
  WY: {
    name: 'Wyoming',
    initialFee: 0,
    renewalFee: 0,
    auditThreshold: 500000,
    reviewThreshold: 250000,
    requirements: ['No Registration Required']
  }
};

export const multiStateRequirements = {
  '2-5': {
    multiplier: 1.2,
    baseRegistration: 2500,
    annualFee: 1500,
    description: '2-5 states registration package'
  },
  '6-10': {
    multiplier: 1.5,
    baseRegistration: 5000,
    annualFee: 3000,
    description: '6-10 states registration package'
  },
  '11-25': {
    multiplier: 2.0,
    baseRegistration: 10000,
    annualFee: 6000,
    description: '11-25 states registration package'
  },
  '26-50': {
    multiplier: 2.5,
    baseRegistration: 15000,
    annualFee: 9000,
    description: 'All states registration package'
  }
};

export const federalRequirements = {
  form990: {
    n: {
      threshold: 50000,
      cost: 0,
      description: 'Form 990-N (e-Postcard)'
    },
    ez: {
      threshold: 200000,
      cost: 2000,
      description: 'Form 990-EZ'
    },
    full: {
      threshold: Infinity,
      cost: 3500,
      description: 'Form 990'
    }
  },
  audit: {
    review: {
      threshold: 250000,
      cost: 7000,
      description: 'Financial Review'
    },
    full: {
      threshold: 750000,
      cost: 12000,
      description: 'Full Audit'
    },
    singleAudit: {
      threshold: 1000000, // Updated per OMB Uniform Guidance effective 10/1/2024
      federalFunds: true,
      cost: 16000,
      description: 'Single Audit (Required for federal funds over $1M)'
    }
  }
};